import { ACTION_TYPE } from "../action/type";

const initialState = {
  cvdDataLoading: false,
  cvdDataSuccess: null,
  cvdDataError: null,
};

export const cvdReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPE.CVD_DATA_REQUEST:
      return {
        ...state,
        cvdDataLoading: true,
        cvdDataError: null,
      };
    case ACTION_TYPE.CVD_DATA_SUCCESS:
      return {
        ...state,
        cvdDataLoading: false,
        cvdDataSuccess: action.payload,
        cvdDataError: null,
      };
    case ACTION_TYPE.CVD_DATA_FAILURE:
      return {
        ...state,
        cvdDataLoading: false,
        cvdDataSuccess: null,
        cvdDataError: action.payload,
      };
    default:
      return state;
  }
};